/*
    This file is used to store often-changed configs used by codeowned parts of RSDK.
    You are free to make changes in here, just be careful of course!
*/

/* Used in modules/Network/axios/getStatsdTagForUrl to prevent unbounded url tags */
export const STATSD_URL_TAG_MAP_ARRAY: Array<{
  regex: RegExp;
  tag: string;
}> = [
  // MORE SPECIFIC REGEXES MUST GO FIRST, FIRST MATCH WINS
  {
    regex: /https:\/\/api\.lever\.co\/v0\/postings\/rover\?group=team&mode=json/,
    tag: 'https://api.lever.co/v0/postings/rover?group=team&mode=json',
  },
  {
    regex: /\/frontend\/homepage-rebooking-profiles\//,
    tag: '/frontend/homepage-rebooking-profiles/',
  },
  {
    regex: /\/frontend\/current-user\//,
    tag: '/frontend/current-user/',
  },
  {
    regex: /\/frontend\/experiments\//,
    tag: '/frontend/experiments/',
  },
  {
    regex: /\/cross-vertical-search-links\//,
    tag: '/cross-vertical-search-links/',
  },
  {
    regex: /\/search-optimized\//,
    tag: '/search-optimized/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/home\//,
    tag: '/people/:personOpk/home/',
  },
  {
    regex: /\/cities-and-neighborhoods\//,
    tag: '/cities-and-neighborhoods/',
  },
  {
    regex: /\/country-configuration\/current\//,
    tag: '/country-configuration/current/',
  },
  {
    regex: /\/country-configuration\/navigation\//,
    tag: '/country-configuration/navigation/',
  },
  {
    regex: /\/country-configuration\//,
    tag: '/country-configuration/',
  },
  {
    regex: /\/frontend\/country-footer-links\//,
    tag: '/country-footer-links/',
  },
  {
    regex: /\/frontend\/country-region-links\//,
    tag: '/frontend/country-region-links/',
  },
  {
    regex: /\/frontend\/events\//,
    tag: '/frontend/events/',
  },
  {
    regex: /\/frontend\/configuration\//,
    tag: '/frontend/configuration/',
  },
  {
    regex: /\/frontend\/django-messages\//,
    tag: '/frontend/django-messages/',
  },
  {
    regex: /\/announcements\/global\//,
    tag: '/announcements/global/',
  },
  {
    regex: /\/bright-horizons\/global-banner\//,
    tag: '/bright-horizons/global-banner/',
  },
  {
    regex: /\/frontend\/href-langs\//,
    tag: '/frontend/href-langs/',
  },
  {
    regex: /\/utilities\/location-autocomplete\//,
    tag: '/utilities/location-autocomplete/',
  },
  {
    regex: /\/utilities\/location-geocode\//,
    tag: '/utilities/location-geocode/',
  },
  {
    regex: /\/utilities\/referral-experiment-config\//,
    tag: '/utilities/referral-experiment-config/',
  },
  {
    regex: /\/announcements\/notifications\//,
    tag: '/announcements/notifications/',
  },
  {
    regex: /\/payment-intents\//,
    tag: '/payment-intents/',
  },
  {
    regex: /\/training\/trainer-profile\/details-data\//,
    tag: '/training/trainer-profile/details-data/',
  },
  {
    regex: /\/grooming-profile\/hub\//,
    tag: '/grooming-profile/hub/',
  },
  {
    regex: /\/grooming-profile\/waitlist\//,
    tag: '/grooming-profile/waitlist/',
  },
  {
    regex: /\/grooming-profile\/details\//,
    tag: '/grooming-profile/details/',
  },
  {
    regex: /\/grooming-profile\/images\//,
    tag: '/grooming-profile/images/',
  },
  {
    regex: /\/grooming-profile\/safety-quiz\//,
    tag: '/grooming-profile/safety-quiz/',
  },
  {
    regex: /\/grooming-profile\/safety-quiz-complete\//,
    tag: '/grooming-profile/safety-quiz-complete/',
  },
  {
    regex: /\/grooming-profile\/navigation\//,
    tag: '/grooming-profile/navigation/',
  },
  {
    regex: /\/grooming-profile\/service-settings\//,
    tag: '/grooming-profile/service-settings/',
  },
  {
    regex: /\/grooming-profile\/testimonial-requests\//,
    tag: '/grooming-profile/testimonial-requests/',
  },
  {
    regex: /\/grooming-profile\/testimonial-request\/[a-zA-Z0-9]+\//,
    tag: '/grooming-profile/testimonial-request/:token/',
  },
  {
    regex: /\/grooming\/rebook\/[^/]+\//,
    tag: '/grooming/rebook/:requesterOpk/',
  },
  {
    regex: /\/frontend\/user-person-summary\//,
    tag: '/frontend/user-person-summary/',
  },
  {
    regex: /\/phones\//,
    tag: '/phones/',
  },
  {
    regex: /\/pets\//,
    tag: '/pets/',
  },
  {
    regex: /\/my-pets\//,
    tag: '/my-pets/',
  },
  {
    regex: /\/seo-location\/.+\/reviews\//,
    tag: '/seo-location/:seoLocationSlug/reviews/',
  },
  {
    regex: /\/seo-location\//,
    tag: '/seo-location/',
  },
  {
    regex: /\/reviews-snippet\//,
    tag: '/reviews-snippet/:city/:region/:serviceType',
  },
  {
    regex: /\/frontend\/service-types\//,
    tag: '/frontend/service-types/',
  },
  {
    regex: /\/frontend\/top-cities\//,
    tag: '/frontend/top-cities/',
  },
  {
    regex: /\/frontend\/footer\//,
    tag: '/frontend/footer/',
  },
  {
    regex: /\/frontend\/homepage-configuration\//,
    tag: '/frontend/homepage-configuration/',
  },
  {
    regex: /\/frontend\/homepage-service-types\//,
    tag: '/frontend/homepage-service-types/',
  },
  {
    regex: /\/frontend\/localized-brand-country\//,
    tag: '/frontend/localized-brand-country/',
  },
  {
    regex: /\/frontend\/service-links\//,
    tag: '/frontend/service-links/',
  },
  {
    regex: /\/frontend\/internal-linking\//,
    tag: '/frontend/internal-linking/',
  },
  {
    regex: /\/people\/full-sitter-profile\//,
    tag: '/people/full-sitter-profile/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/public-calendar\//,
    tag: '/people/:opk/public-calendar/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/reviews\//,
    tag: '/people/:opk/reviews/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/stay-media\//,
    tag: '/people/:opk/stay-media/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/images\//,
    tag: '/people/:opk/images/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/?\??/,
    tag: '/people/:opk/',
  },
  {
    regex: /\/provider-profile\/hub\//,
    tag: '/provider-profile/hub/',
  },
  {
    regex: /\/provider-profile\/cat-profile\//,
    tag: '/provider-profile/cat-profile/',
  },
  {
    regex: /\/provider-profile\/existing-provider-sign-up\/[a-zA-Z0-9-]+\/cat-profile\//,
    tag: '/provider-profile/existing-provider-sign-up/:serviceSlug/cat-profile/',
  },
  {
    regex: /\/frontend\/service-landing\//,
    tag: '/frontend/service-landing/',
  },
  {
    regex: /\/grooming\/search\//,
    tag: '/grooming/search/',
  },
  {
    regex: /\/grooming\/search-results\//,
    tag: '/grooming/search-results/',
  },
  {
    regex: /\/grooming\/experience-gating\//,
    tag: '/grooming/experience-gating/',
  },
  {
    regex: /\/grooming\/members\/[^/]+\//,
    tag: '/grooming/members/:slug/',
  },
  {
    regex: /\/grooming\/[^/]+\/contact\//,
    tag: '/grooming/:slug/contact/',
  },
  {
    regex: /\/grooming\/recurring-schedules\/[\w-]+\//,
    tag: '/grooming/recurring-schedules/:opk/',
  },
  {
    regex: /\/grooming\/recurring-schedules\//,
    tag: '/grooming/recurring-schedules/',
  },
  {
    regex: /\/reviews\/trainer-testimonial-requests\/[a-zA-Z0-9]+\//,
    tag: '/reviews/trainer-testimonial-requests/:token/',
  },
  {
    regex: /\/reviews\/trainer-testimonial-requests\//,
    tag: '/reviews/trainer-testimonial-requests/',
  },
  {
    regex:
      /\/training\/members\/[a-zA-Z-]+\/services\/[a-zA-Z-]+\/bundle-offerings\/[a-zA-Z0-9]+\//,
    tag: '/training/members/:providerSlug/services/:serviceSlug/bundle-offerings/:opk/',
  },
  {
    regex: /\/training\/members\/[a-zA-Z-]+\/services\/[a-zA-Z-]+\/bundle-offerings\//,
    tag: '/training/members/:providerSlug/services/:serviceSlug/bundle-offerings/',
  },
  {
    regex: /\/training\/members\/[a-zA-Z-]+\/services\/[a-zA-Z-]+\/session-type-options\//,
    tag: '/training/members/:providerSlug/services/:serviceSlug/session-type-options/',
  },
  {
    regex: /\/training\/members\/[a-zA-Z-]+\/services\/[a-zA-Z-]+\/bundle-request\//,
    tag: '/training/members/:providerSlug/services/:serviceSlug/bundle-request/',
  },
  {
    regex:
      /\/training\/members\/[a-zA-Z-]+\/services\/[a-zA-Z-]+\/bundle-relationship\/[a-zA-Z0-9]+\/session\//,
    tag: '/training/members/:providerSlug/services/:serviceSlug/bundle-relationship/:opk/session/',
  },
  {
    regex: /\/training\/members\/[^/]+\/nearby-trainer-count\//,
    tag: '/training/members/:slug/nearby-trainer-count/',
  },
  {
    regex: /\/training\/members\/[^/]+\//,
    tag: '/training/members/:slug/',
  },
  {
    regex: /\/training\/trainer-testimonials\/add\//,
    tag: '/training/trainer-testimonials/add/',
  },
  {
    regex: /\/training\/methodology-requirement\//,
    tag: '/training/methodology-requirement/',
  },
  {
    regex: /\/training\/certification-requirement\//,
    tag: '/training/certification-requirement/',
  },
  {
    regex: /\/training\/trainer-profile\/behaviors\//,
    tag: '/training/trainer-profile/behaviors/',
  },
  {
    regex: /\/training\/behavior-skill-options\//,
    tag: '/training/behavior-skill-options',
  },
  {
    regex: /\/training\/trainer-profile\/skills\//,
    tag: '/training/trainer-profile/skills/',
  },
  {
    regex: /\/training\/trainer-profile\/behaviors-custom\//,
    tag: '/training/trainer-profile/behaviors-custom/',
  },
  {
    regex: /\/training\/trainer-profile\/skills-custom\//,
    tag: '/training/trainer-profile/skills-custom/',
  },
  {
    regex: /\/training\/trainer-profile\/details\//,
    tag: '/training/trainer-profile/details/',
  },
  {
    regex: /\/training\/search-results\//,
    tag: '/training/search-results/',
  },
  {
    regex: /\/training\/trainer-profile\/education\//,
    tag: '/training/trainer-profile/education/',
  },
  {
    regex: /\/provider-profile\/person\/[a-zA-Z-]+\//,
    tag: '/provider-profile/person/:service_preferences_slug/',
  },
  {
    regex: /\/training\/certification-interest-confirmation\//,
    tag: '/training/certification-interest-confirmation/',
  },
  {
    regex: /\/training\/conversations\/[a-zA-Z0-9]+\/video-link\//,
    tag: '/training/conversations/:conversation_opk/video-link/',
  },
  {
    regex: /\/training\/conversations\/[a-zA-Z0-9]+\/bundle-request\//,
    tag: '/training/conversations/:conversation_opk/bundle-request/',
  },
  {
    regex: /\/training\/conversations\/[a-zA-Z0-9]+\/bundle-purchase\//,
    tag: '/training/conversations/:conversation_opk/bundle-purchase/',
  },
  {
    regex: /\/training\/conversations\/[a-zA-Z0-9]+\/pricing\/[a-zA-Z0-9]+\/bundle-session\//,
    tag: '/training/conversations/:conversation_opk/pricing/:conversation_version/bundle-session/',
  },
  {
    regex: /\/training\/conversations\/[a-zA-Z0-9]+\/pricing\/[a-zA-Z0-9]+\/bundle\//,
    tag: '/training/conversations/:conversation_opk/pricing/:conversation_version/bundle/',
  },
  {
    regex: /\/training\/contact-more-trainers\/[a-zA-Z0-9]+\/recommendation\//,
    tag: '/training/contact-more-trainers/:conversation_opk/recommendation/',
  },
  {
    regex: /\/conversations\/[a-zA-Z0-9]+\//,
    tag: '/conversations/:conversation_opk/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/services\/[^/]+\//,
    tag: '/people/:opk/services/:service_slug/',
  },
  {
    regex: /\/training\/session-cancellation-reasons\/(provider|owner)\//,
    tag: '/training/session-cancellation-reasons/:user_type/',
  },
  {
    regex: /\/order\/[a-zA-Z0-9]+/,
    tag: '/order/:opk/',
  },
  {
    regex: /\/checkout\/[a-zA-Z0-9]+\/screen\//,
    tag: '/checkout/:opk/screen/',
  },
  {
    regex: /\/checkout\/[a-zA-Z0-9]+\/confirmation-details/,
    tag: '/checkout/:opk/confirmation-details/',
  },
  {
    regex: /\/training\/video-link\/[a-zA-Z0-9-]+\//,
    tag: '/training/video-link/:token/',
  },
  {
    regex: /\/lemonade-pet-user-form\//,
    tag: '/lemonade-pet-user-form/',
  },
  {
    regex: /\/referral\/[a-zA-Z0-9]+\/details\//,
    tag: '/referral/:opk/details/',
  },
  {
    regex: /\/recap-2025\//,
    tag: '/recap-2025/',
  },
  {
    regex: /\/blocking-modal\/marketing-opt-in\//,
    tag: '/blocking-modal/marketing-opt-in/',
  },
  {
    regex: /\/bright-horizons\/sitter-profile-banner\//,
    tag: '/bright-horizons/sitter-profile-banner/',
  },
  {
    regex: /\/training\/credential-organizations\//,
    tag: '/training/credential-organizations/',
  },
  {
    regex: /\/training\/trainer-application-reset\//,
    tag: '/training/trainer-application-reset/',
  },
  {
    regex: /\/training\/credentials-upload\//,
    tag: '/training/credentials-upload/',
  },
  {
    regex: /\/training\/conversations\/(?:\?|$)/,
    tag: '/training/conversations/',
  },
  {
    regex: /\/training\/conditional-consultation-intent\//,
    tag: '/training/conditional-consultation-intent/',
  },
  {
    regex: /\/training\/trainer-recruitment\/profile\/dismiss\//,
    tag: '/training/trainer-recruitment/profile/dismiss/',
  },
  {
    regex: /\/training\/bundle-offering-promotion\/dismiss\//,
    tag: '/training/bundle-offering-promotion/dismiss/',
  },
  {
    regex: /\/training\/trainer-profile\/sign-up\//,
    tag: '/training/trainer-profile/sign-up/',
  },
  {
    regex: /\/reviews\/trainer-testimonials\//,
    tag: '/reviews/trainer-testimonials/',
  },
  {
    regex: /\/reviews\/trainer-reviews\//,
    tag: '/reviews/trainer-reviews/',
  },
  {
    regex: /\/provider-profile\/trainer-sitter-sign-up\/[a-zA-Z-]+\//,
    tag: '/provider-profile/trainer-sitter-sign-up/:serviceSlug/',
  },
  {
    regex: /\/provider-profile\/trainer-profile\/resubmit\//,
    tag: '/provider-profile/trainer-profile/resubmit/',
  },
  {
    regex: /\/me\//,
    tag: '/me/',
  },
  {
    regex: /\/relationships\/(?:\?|$)/,
    tag: '/relationships/',
  },
  {
    regex: /\/provider-profile\/provider-state\//,
    tag: '/provider-profile/provider-state/',
  },
  {
    regex: /\/screens\/contact-more-sitters\/[a-zA-Z0-9]+\//,
    tag: '/screens/contact-more-sitters/:conversationOpk/',
  },
  {
    regex: /\/screens\/relationship-tracker\/[a-zA-Z0-9]+\/(?:\?|$)/,
    tag: '/screens/relationship-tracker/:opk/',
  },
  {
    regex: /\/api_key\/password\/web\//,
    tag: '/api_key/password/web/',
  },
  {
    regex: /\/api_key\/password\//,
    tag: '/api_key/password/',
  },
  {
    regex: /\/api_key\/google\//,
    tag: '/api_key/google/',
  },
  {
    regex: /\/api_key\/facebook\//,
    tag: '/api_key/facebook/',
  },
  {
    regex: /\/api_key\/(?:\?|$)/,
    tag: '/api_key/',
  },
];

/* Used in modules/Data/Core/MobileFeatureFlag.native
     native flags are checked by passing these lowercase snakecase strings across the isFeatureFlagActive bridge
  */
export const NATIVE_APP_FLAGS = [
  'rollout_sitter_leaves_feedback_m5_pet_feedback',
  'rollout_sitter_leaves_review_m5',
  'rollout_negative_pet_feedback_iteration',
  'rollout_known_pets_sitter_feedback',
  'rollout_ios_native_help_center',
  'rollout_android_native_help_center',
  'rollout_provider_embedded_request_editor',
  'rollout_sitter_promotion_m0_entry_points',
] as const;

/** Used in modules/Data/Core/FrontendConfiguration
 * human-readable names for the hashes on the frontendConfiguration.flags API response
 */
export const FRONTEND_CONFIGURATION_FLAGS = {
  CAT_REVIEWS_IN_SEARCH_EXPERIMENT: '0dbadb3de3c4c09e01f86be00d8a409e9c7cd438',
  DEVICE_CURRENT_LOCATION_EXPERIMENT: '0367fc4fe5952478f3bd3c719a6c7e9ee8a079cd',
  QUICK_FACTS_EXPERIMENT: '6084a8f35600ecf3a7c8ecbba3e9cf061fcebc0a',
  REPEAT_SEARCH_EXPERIMENT_20180620_VARIANT: '6b74ac8a0fb97f8f8e50321354750a4afabb4e8a',
  ROLLOUT_INPUT_DEPENDENT_PERFORMANCE: 'e6f88f0aef4bba4a153f072a86bfa039e2b5659d',
  ROLLOUT_INTERNAL_LINKING: '045b9979887329d4a8981b39b5f50475c16f0dbc',
  ROLLOUT_KETCH_COOKIE_CONSENT: 'a45c39ca9259ae0c55d0a159a502938aef891fba',
  ROLLOUT_SITTER_INSIGHTS_ALL_CHARTS: '8a1259985afbbcfb28ca301664779a61a82ea43f',
  ROLLOUT_SITTER_INSIGHTS_PROFILE_VIEWS_CHART: 'b5f0574d0f254849a37a1be5400cbec896c46ea4',
  ROLLOUT_SSR_SEARCH_SESSION_REPLAY: 'a4da5bafaf9e1573b4f37f775ace748359c16a3c',
  ROLLOUT_TRUSTPILOT_BADGE_SCRIPT: '88e2595d30a2fc18be1c79637587d6e5eeb9a5ca',
  ROLLOUT1_SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM: '2814f3822b77980fdf9f5204d8293aaba91f579c',
  ROLLOUT2_SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM: '94b0fadfb590f79dbc6acfcd5fbe9d43eeea9f3d',
  ROLLOUT3_SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM: 'cb95342fb13803a9ccd526ea6bed43f47be36b10',
  ROLLOUT_SITTER_LEAVES_REVIEW_M5: '7a8ff857c9a9ff310e25d0b569620204eba749d4',
  KILLSWITCH_ROVER_PROTECT_CH_2_SURVEY: 'f922229a9ca23e9836709427b5fc106c3dae7f16',
  ROLLOUT_DOG_TRAINING_PILOT: 'cd1faa4fe50e12bec2b16cfae00a845f8fd2bdb9',
  ROLLOUT_AMPLITUDE_ANALYTICS_WEB: 'a3424f5bc57ccdcfe677d32a70d157981d82ab4f',
  ROLLOUT_TRAINER_SIGN_UP: 'd062d043aef0b5e808a4711a6fa9983e167e388d',
  ROLLOUT_DOG_TRAINING_ENTRYPOINTS: '7e5fe227c7c4a45be9727143229a8eee75ad73e8',
  ROLLOUT_TRAINING_SUPPRESS_APP_INSTALL_BANNER: '499a01735b53b2a666e350e70743c9270f3883ae',
  ROLLOUT_TRAINING_PAID_CONSULTATIONS: '599969e44ecc3b9ddfe2a62ef31331f15e948288',
  KILLSWITCH_ALLOW_PET_CREATION_VIA_NEW_PET_FORM: 'aef203a24520095d0a8152af14d203d7e5325c4e',
  ROLLOUT_TRAINING_FREE_CONSULTATIONS: '4aadcf345f5d077afe2e9d8132cda1d44d903c3b',
  ROLLOUT_PROVIDER_BUNDLE_OFFERINGS: 'b3dded3660ba9e955b6a5a7624cecca034761e6a',
  ROLLOUT_SITTER_PROMOTION_M0_ENTRY_POINTS: 'd74057c86b7fe6a79e65ea4b38e1a962a65187fc',
  ROLLOUT_TRAINING_BUNDLES: '3cbc9ffa121c95d5def8362761baa1c781b6ae02',
  KILLSWITCH_TRAINING_BUNDLE_CREATE_OFFERINGS: '434e52691e2a2b6da392f9533b552aa4976e1a26',
  KILLSWITCH_TRAINING_BUNDLE_VIEW_OFFERINGS: '6f77fed64e9a8d5d4753b201fc2a4f000c02064e',
  ROLLOUT_ROVER_COLLECT_VACCINATION_DOCUMENTS: '2c8a0804131ea041a2c5b4cf0ae9b4f8ba30687f',
  ROLLOUT_LEMONADE_PET_INSURANCE: 'c81af454ccc8922e749fbba81fb7ad0134de59ba',
  ROLLOUT_USER_MIGRATION_LANDING_PAGE: '74638b2580ce37d9dc4b5d67fa8476b01e053fb3',
  ROLLOUT_USER_PRE_MIGRATION_LANDING_PAGE: 'a6bb5ac23d7d006f41db0e283356d2c32a42eeef',
  KILLSWITCH_TRAINING_REBOOKING_NOTIFICATION_TASKS: '3b5f51907b1663bee05566b0b7130a666f853d0a',
  KILLSWITCH_TRAINING_SEND_REBOOKING_NOTIFICATIONS: 'df785ac0905e421afcbf22954cce5ad4109b63fa',
  ROLLOUT_SNAPPINGCAROUSEL_V2: '0e5f67ed8de9fa98e91f850f4a6e3e9c630d140c',
  ROLLOUT_AMBASSADOR_OWNER_ENTRY_POINTS_UPLIFTS: 'ef5d56151553e1066211d3144774984d5860884a',
  ROLLOUT_DEFAULT_TO_HOME_ADDRESS: 'f3d1f4478c5dab6c4c50b83d103c26440f203b1b',
  PET_INFO_CHIPS: 'a6cc372cdb9921568dfc48da5e2c68b800ae7ca8',
  ROLLOUT_GROOMING_SIGN_UP_FOR_REQUEST: '6c0e2f60214b7cd6dad6178efad4b95666b6f472',
  ROLLOUT_GROOMING_OWNER_FUNNEL: '5b40b279e07d87673c696b5267a47061d0863f1b',
  ROLLOUT_RECURRING_GROOMING: '5717d1688f14aafd787561968e8176dc9cbe385c',
  ROLLOUT_PET_INFO_CALLOUT_EXPERIMENT: 'd1fc64035a21386b18e11f11e1747922617d7e86',
  ROLLOUT_KNOWN_OWNERS_M1_EXPERIMENT: '55d6526f273c9d1c35621d21c5ddd55bf5db4ea1',
  ROLLOUT_KNOWN_OWNERS_M2: '7109f05efd977cbdc21bb45c5f9f25007836f434',
  IS_V4_SIMPLIFIED_MOBILE_SEARCH_FILTERS: '1097e9d44d7b8f617d55e7293c4b4722a04d935a',
  ROLLOUT_TRAINING_ALL_SERVICE_CLIENT_COUNT: '51501d5c7bd5e45537092c85eff45954d58e8224',
  ROLLOUT_TRAINING_REVIEW_REBOOKING_FLOW_M1: '3ac7c3e043eea49400334f99226a3d7183f54d70',
  ROLLOUT_MOBILE_FILTERS_M2: '480295bc09e6ec734b56c1d37f54afbf597cb642',
  IS_SITTER_GALLERY_CROP_FIX_EXPERIMENT: 'e9a6cec4b405b735f199b94ab58ff708d1192ce1',
  ROLLOUT_GOODPUP_CERTIFICATION_LANDING_PAGE: '0a8ff3fc45e68f632d7538cbdc735f44c60018f0',
  ROLLOUT_GROOMING_BREED_SPECIFIC_PRICING: '6d87fc5653436960e3b350509c4c13fe24a5faf8',
  ROLLOUT_HOME_PAGE_TRAINING_SERVICE_OPTION: '68fe45df51864624b289609ffe36cffa190cb997',
  ROLLOUT_HOMEPAGE_REVIEWS_CAROUSEL: 'c6c071db55aefd62e9494b6a8b0b2c2be860d9d5',
  RECURRING_SCHEDULE_WEB_MANAGEMENT: '26d19de6388cda46fe2e6cb0c96680478fd304d4',
  ROLLOUT_TSU_TALENTLMS_LINKING: 'b5b6c4824c5ce2fafec677cf6008d17089dc1e31',
  GEO_BROWSE_HOMEPAGE_ENTRYPOINT: '3f75ef5fe540abac640eae062dfbdc526a20e68f',
  ROLLOUT_TSU_BUNDLE_ENABLEMENT_M1: '857a1e0dfd7a1aa4d8c59eca680f40cc9e4e390a',
  ROLLOUT_TRAINING_BUNDLE_TEMPLATES: '0006497bfe632f4324f30090e6f1ac763c5e2f6c',
  ROLLOUT_MANAGEMENT_HUB_MIGRATION: 'fc34d7ef4afbae5dce5a91c034713493f28460c8',
  ROLLOUT_UPDATED_TRAINER_PROFILE_DETAILS: '7a9ddd8f6e87f31c42865cadb68ff6943af6e6a3',
  ROLLOUT_CHANGE_SIGN_UP_SERVICE: 'e207d6e859ae4147a7a3a1af84bfcc31d9a652ad',
} as const;

/* Used in modules/Data/Core/MobileExperiment.native
     native experiments are checked by passing these values across getExperimentBucket bridge
  */
export const NATIVE_EXPERIMENTS = {
  PAYPAL_PAYINS_ANDROID: 'Paypal Payins on Android',
  PAYPAL_PAYINS_IOS: 'Paypal Payins on iOS',
  PAYMENT_SHEET_IOS: 'iOS Payment Sheet Experiment',
  ADD_CC_POST_REQUEST_IOS: 'iOS Add Credit Card Post Request v1',
  ADD_CC_POST_REQUEST_ANDROID: 'Android Add Credit Card Post Request v1',
  SAVE_PAYMENT_METHOD_POST_CONTACT: 'save_payment_method_post_contact_native',
} as const;
